import { musicPlatform } from 'fitbeat.gym-core/config';
import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, TouchableOpacity, View} from 'react-native';
import FastImage from 'react-native-fast-image';
import { connect } from 'react-redux';
import AppleMusicIcon from '../../../assets/images/appleMusic.svg';
import SpotifyIcon from '../../../assets/images/spotify.svg';
import Theme from '../../../theme';
import { defaultScale } from '../../../utils/scaling';
import { IAppStore } from '../../reducer';
import { orientationSelector } from '../../selectors';
import { playlistSelected } from './actions';
import { IPlaylist } from './interfaces';
import { tileImages } from './MusicControlSection';
import { getSelectedMusicPlayerSelector } from './selectors';

interface IProps {
  playlistSelected: (playlist: IPlaylist) => void;
  playlistItem: IPlaylist;
  orientation: string;
  userPlaylist: boolean;
  musicPlayer: musicPlatform;
}

const PlaylistAlbumTileComponent: FunctionComponent<IProps> = ({ playlistItem, userPlaylist = false, ...props }) => {

  const length = () => {
    if (props.orientation === 'PORTRAIT') {
      return 160;
    }
    return 180;
  };

  const playlistDisplayImage = () => {
    if (playlistItem.image && playlistItem.image !== ';') {
      const imageSource = typeof playlistItem.image === 'string' ? {
        uri: playlistItem.image,
      } : playlistItem.image;
      return (
        <FastImage
          style={{ width: defaultScale(length()), height: defaultScale(length()) }}
          source={imageSource}
        />
      );
    } else if (userPlaylist && (!playlistItem.image || playlistItem.image === ';')) {
      if (props.musicPlayer === musicPlatform.AppleMusic) {
        return <AppleMusicIcon width={defaultScale(length() / 4)} height={defaultScale(length() / 4)}/>;
      }
      return <SpotifyIcon width={defaultScale(length() / 4)} height={defaultScale(length() / 4)}/>;
    }
    return (
      <FastImage
        resizeMode='contain'
        style={{ width: defaultScale(length() / 4), height: defaultScale(length() / 4) }}
        source={tileImages.PLACEHOLDER}
      />
    );
  }

  return (
    <TouchableOpacity style={[styles.tileContainer, { width: defaultScale(length()) }]}
                      onPress={() => props.playlistSelected(playlistItem)}>
      <View style={[styles.tile, { width: defaultScale(length()), height: defaultScale(length()) }]}>
        {playlistDisplayImage()}
      </View>
      <View>
        <Text style={styles.playlistTitle}>{playlistItem.title}</Text>
      </View>
    </TouchableOpacity>
  );
};

const mapStateToProps = (state: IAppStore) => {
  return {
    orientation: orientationSelector(state),
    musicPlayer: getSelectedMusicPlayerSelector(state),
  };
};

export const PlaylistAlbumTile = connect(mapStateToProps, { playlistSelected })(PlaylistAlbumTileComponent);

const styles = StyleSheet.create({
  tileContainer: {
    alignItems: 'center',
    marginHorizontal: defaultScale(8),
    marginBottom: defaultScale(24),
  },
  tile: {
    borderWidth: 2,
    borderColor: 'black',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
    backgroundColor: Theme.CHARCOAL,
  },
  playlistTitle: {
    ...Theme.textStyle.bodyCopyReg,
    justifyContent: 'center',
    marginTop: defaultScale(7),
    color: Theme.WHITE,
  },
});
